var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('d-modal',{attrs:{"name":"docs","popup-title":"Документы","size":"wide"}},[_c('p',{staticClass:"d-modal__text p1"},[_vm._t("docs")],2),_c('br')]),_c('d-modal',{attrs:{"name":"archive","popup-title":"Архив","size":"wide"}},[_c('p',{staticClass:"d-modal__text p1"},[_vm._t("archive")],2),_c('br')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }